import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mobileMenuOpen: false,
};

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setMobileMenuOpen(state, { payload }) {
      return { ...state, mobileMenuOpen: payload };
    },
  },
});

export const { setMobileMenuOpen } = layoutSlice.actions;

export const getLayout = (state: IReducerStates) => state.layout;
